
import adminAuthService from "./adminAuthService";


const BASE_URL =
    process.env.REACT_APP_API_URL;


// export const loginAdmin = async (username, password) => {
//     try {
//         const url = `${BASE_URL}/subscription/api/auth/login/admin?identifier=${username}&password=${password}`;

//         const response = await fetch(url, {
//             method: "POST",
//             headers: {
//                 Accept: "application/json",
//             },
//             credentials: "include",
//         });

//         if (!response.ok) {
//             throw new Error("Login request failed");
//         }

//         const data = await response.json();

//         return data;
//     } catch (error) {
//         console.error("Service Error:", error);
//         throw error;
//     }
// };

// ================= SIGNUP API =================

// Update loginAdmin function to use adminAuthService
export const loginAdmin = async (username, password) => {
    try {
        const url = `${BASE_URL}/subscription/api/auth/login/admin?identifier=${username}&password=${password}`;

        const response = await fetch(url, {
            method: "POST",
            headers: { Accept: "application/json" },
            credentials: "include",
        });

        if (!response.ok) {
            throw new Error("Login request failed");
        }

        const data = await response.json();

        // ✅ Store tokens using adminAuthService
        adminAuthService.setAuthData(data);

        return data;
    } catch (error) {
        console.error("Service Error:", error);
        throw error;
    }
};

export const signupAdmin = async (requestBody) => {
    try {
        const response = await fetch(
            `${BASE_URL}/admin/registration`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            }
        );

        const contentType =
            response.headers.get("content-type") || "";

        let data = null;

        if (contentType.includes("application/json")) {
            data = await response.json().catch(() => null);
        } else {
            data = await response.text().catch(() => null);
        }

        return {
            success: response.ok,
            status: response.status,
            data,
        };
    } catch (error) {
        console.error("Signup API Error:", error);

        return {
            success: false,
            status: 500,
            data: error.message,
        };
    }
};


// ================= REFRESH TOKEN API =================

export const refreshAuthToken = async () => {
    try {
        const response = await fetch(
            `${BASE_URL}/auth/refresh`,
            {
                method: "POST",
                credentials: "include",
            }
        );

        if (!response.ok) {
            return null;
        }

        const data = await response.json();

        localStorage.setItem("authToken", data.token);

        return data.token;
    } catch (error) {
        console.error("Refresh Token Error:", error);
        return null;
    }
};
export const forgotPasswordAPI =
    async (email) => {
        try {
            const response = await fetch(
                `${BASE_URL}/subscription/forgot/password`,
                {
                    method: "POST",

                    headers: {
                        "Content-Type":
                            "application/json",

                        Accept: "*/*",
                    },

                    body: JSON.stringify({
                        identifier: email,
                    }),
                }
            );

            const text =
                await response.text();

            if (!response.ok) {
                throw new Error(
                    text ||
                    "Something went wrong."
                );
            }

            return text;

        } catch (error) {
            console.error(
                "Forgot password error:",
                error
            );

            throw error;
        }
    };
export const resetPasswordAPI =
    async ({
        token,
        newPassword,
        confirmPassword,
    }) => {
        try {
            const response = await fetch(
                `${BASE_URL}/subscription/forgot/reset/${token}`,
                {
                    method: "POST",

                    headers: {
                        "Content-Type":
                            "application/json",
                    },

                    body: JSON.stringify({
                        token,
                        newPassword,
                        confirmPassword,
                    }),
                }
            );

            const data =
                await response.text();

            if (!response.ok) {
                throw new Error(
                    data ||
                    "Reset failed."
                );
            }

            return data;

        } catch (error) {
            console.error(
                "Reset password error:",
                error
            );

            throw error;
        }
    };